import { SVGProps } from 'react';
import { InterpolationValue } from 'styled-components';
import { TriageMessageLevel } from '../../schema/hannibal/types.generated';
import { ThemeColours } from '../../styles/ThemeColours';
import IconCircleError from '../icons/IconCircleError.svg';
import IconCircleInfo from '../icons/IconCircleInfo.svg';
import IconCircleTick from '../icons/IconCircleTick.svg';

export const AlertVariants = {
  Success: {
    primary: ThemeColours.positive,
    secondary: ThemeColours.positive50,
    Icon: IconCircleTick,
  },
  Danger: {
    primary: ThemeColours.negative,
    secondary: ThemeColours.negative100,
    Icon: IconCircleError,
  },
  Warning: {
    primary: ThemeColours.warning500,
    secondary: ThemeColours.warning100,
    Icon: IconCircleError,
  },
  Info: {
    primary: ThemeColours.primary,
    secondary: ThemeColours.primary50,
    Icon: IconCircleInfo,
  },
} as const;

export interface Variant {
  primary: InterpolationValue;
  secondary: InterpolationValue;
  Icon: (props: SVGProps<SVGElement>) => JSX.Element;
}

export const triageMessageLevelToAlertVariant = (level: TriageMessageLevel): Variant =>
  level === TriageMessageLevel.Warning ? AlertVariants.Warning : AlertVariants.Info;
